import PropTypes from 'prop-types'
import { iconSizes } from '../icons-sizes'
import { SvgIconComponent } from '../styledComponents'

export function Shovel({ size, ...props }) {
  return (
    <SvgIconComponent
      height="16"
      width="17"
      fill="none"
      viewBox="0 0 17 16"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
      stroke="#141A21"
    >
      <path
        d="M13.1924 1.99997L7.71484 7.47754L9.01877 8.78146L14.4963 3.30389L13.1924 1.99997Z"
        stroke="inehit"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.666667"
      />
      <path
        d="M7.19525 6.95905L6.15137 8.00293L8.49916 10.3507L9.54304 9.30684L7.19525 6.95905Z"
        stroke="inehit"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.666667"
      />
      <path
        d="M9.28198 11.1309L6.87197 13.5409C6.57724 13.8357 6.18079 14 5.76608 14H3.80729C3.08742 14 2.50317 13.4158 2.50317 12.6959V10.7371C2.50317 10.3224 2.66749 9.92332 2.96222 9.6312L5.37224 7.22119L9.2846 11.1335L9.28198 11.1309Z"
        stroke="inehit"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.666667"
      />
      <path
        d="M6.67367 9.82678L4.06543 12.435"
        stroke="inehit"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.666667"
      />
      <path
        d="M10.8469 10.8702L13.716 8.0011"
        stroke="inehit"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.666667"
      />
      <path
        d="M11.1077 14L13.9767 11.131"
        stroke="inehit"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.666667"
      />
      <path
        d="M6.41284 5.13204L9.02108 2.5238"
        stroke="inehit"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.666667"
      />
      <path
        d="M2.50049 5.65361L5.36955 2.78455"
        stroke="inehit"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.666667"
      />
    </SvgIconComponent>
  )
}

export function VersionInfo({ size, ...props }) {
  return (
    <SvgIconComponent
      height="39"
      width="38"
      fill="none"
      viewBox="0 0 38 39"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M1 8.25H37M7.75 19.5H5.5M7.75 19.5V30.75M7.75 19.5H12.25V30.75M14.5 30.75H12.25M12.25 30.75H7.75M7.75 30.75H5.5M17.3951 16.617H30.8951M17.3951 24.117H30.8951M17.3951 27.867H27.718M17.3951 20.367H21.8951M25.4169 20.367H30.8951M2.125 1.5H35.875C36.1734 1.5 36.4594 1.61861 36.6704 1.82959C36.8814 2.04057 37 2.32663 37 2.625V37.5H1V2.625C1 2.32663 1.11861 2.04057 1.32959 1.82959C1.54057 1.61861 1.82663 1.5 2.125 1.5ZM27.601 4.31396C27.4895 4.31396 27.3805 4.34702 27.2877 4.409C27.195 4.47097 27.1226 4.55917 27.0799 4.66223C27.0372 4.76529 27.0261 4.87857 27.0479 4.98798C27.0696 5.09738 27.1233 5.19786 27.2022 5.27673C27.2811 5.35561 27.3816 5.40933 27.491 5.43109C27.6004 5.45285 27.7138 5.44174 27.8169 5.39905C27.92 5.35636 28.008 5.28416 28.0699 5.19141C28.1319 5.09866 28.165 4.98948 28.165 4.87793C28.165 4.72835 28.1056 4.5849 27.9998 4.47913C27.894 4.37336 27.7506 4.31396 27.601 4.31396ZM30.5831 4.31396C30.4715 4.31396 30.3623 4.34702 30.2696 4.409C30.1768 4.47097 30.1046 4.55917 30.062 4.66223C30.0193 4.76529 30.0081 4.87857 30.0299 4.98798C30.0517 5.09738 30.1054 5.19786 30.1843 5.27673C30.2631 5.35561 30.3636 5.40933 30.473 5.43109C30.5824 5.45285 30.6957 5.44174 30.7988 5.39905C30.9018 5.35636 30.99 5.28416 31.052 5.19141C31.114 5.09866 31.147 4.98948 31.147 4.87793C31.1474 4.80375 31.1331 4.73029 31.1049 4.66168C31.0767 4.59307 31.0351 4.53085 30.9826 4.47839C30.9302 4.42594 30.8679 4.38428 30.7993 4.35608C30.7307 4.32788 30.6572 4.31357 30.5831 4.31396ZM33.5649 4.31396C33.4534 4.31396 33.3444 4.34702 33.2516 4.409C33.1589 4.47097 33.0867 4.55917 33.044 4.66223C33.0013 4.76529 32.99 4.87857 33.0118 4.98798C33.0335 5.09738 33.0873 5.19786 33.1661 5.27673C33.245 5.35561 33.3455 5.40933 33.4549 5.43109C33.5643 5.45285 33.6778 5.44174 33.7808 5.39905C33.8839 5.35636 33.9719 5.28416 34.0339 5.19141C34.0958 5.09866 34.1291 4.98948 34.1291 4.87793C34.1291 4.72835 34.0695 4.5849 33.9637 4.47913C33.858 4.37336 33.7145 4.31396 33.5649 4.31396ZM10 12.75C9.55499 12.75 9.11995 12.882 8.74994 13.1292C8.37993 13.3764 8.0915 13.7279 7.9212 14.139C7.75091 14.5502 7.7064 15.0024 7.79321 15.4389C7.88003 15.8754 8.09433 16.2763 8.409 16.591C8.72366 16.9057 9.12464 17.12 9.5611 17.2068C9.99755 17.2936 10.4498 17.2491 10.861 17.0788C11.2721 16.9085 11.6236 16.6201 11.8708 16.2501C12.118 15.8801 12.25 15.445 12.25 15C12.25 14.4033 12.013 13.831 11.591 13.409C11.169 12.987 10.5967 12.75 10 12.75Z"
        stroke="#007749"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </SvgIconComponent>
  )
}

export function AppMobileIcon({ size, ...props }) {
  return (
    <SvgIconComponent
      height="36"
      width="36"
      fill="none"
      viewBox="0 0 36 36"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <g filter="url(#filter0_dd_3753_74673)">
        <g clipPath="url(#clip0_3753_74673)">
          <g clipPath="url(#clip1_3753_74673)">
            <rect
              height="47.0909"
              width="47.0909"
              fill="#F6F6FA"
              transform="translate(-5.8075 -5.80762)"
            />
            <path
              d="M20.5453 15.4715C20.3712 15.9589 20.138 16.3732 19.842 16.7178C19.5461 17.0625 19.198 17.3271 18.7977 17.5185C18.3973 17.71 17.9587 17.804 17.4818 17.804C16.507 17.804 15.7063 17.4454 15.0762 16.7283C14.4461 16.0111 14.1328 15.0642 14.1328 13.8771C14.1328 13.3027 14.2198 12.7736 14.3904 12.2862C14.5645 11.7988 14.7942 11.3846 15.0936 11.0399C15.3895 10.6953 15.7411 10.4307 16.1519 10.2392C16.5627 10.0478 17.0048 9.95377 17.4852 9.95377C18.4391 9.95377 19.2328 10.3123 19.8629 11.0295C20.493 11.7466 20.8064 12.6935 20.8064 13.8806C20.8064 14.455 20.7193 14.9842 20.5487 15.4715M17.6071 6.21143C13.2416 6.21143 9.70465 9.51861 9.70465 13.5986C9.70465 18.9354 17.6071 28.8848 17.6071 28.8848C17.6071 28.8848 25.5095 18.9354 25.5095 13.5986C25.506 9.51861 21.9691 6.21143 17.6071 6.21143Z"
              fill="url(#paint0_linear_3753_74673)"
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          height="34.8235"
          id="filter0_dd_3753_74673"
          width="34.8235"
          x="0.588235"
          y="0.988235"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood result="BackgroundImageFix" floodOpacity="0" />
          <feGaussianBlur stdDeviation="0.705882" />
          <feGaussianBlur stdDeviation="0.235294" />
          <feBlend
            result="effect1_dropShadow_3753_74673"
            in2="BackgroundImageFix"
          />
          <feBlend
            result="effect2_dropShadow_3753_74673"
            in2="effect1_dropShadow_3753_74673"
          />
          <feBlend
            result="shape"
            in="SourceGraphic"
            in2="effect2_dropShadow_3753_74673"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3753_74673"
          gradientUnits="userSpaceOnUse"
          x1="13.7081"
          x2="22.7593"
          y1="6.21143"
          y2="28.8395"
        >
          <stop stopColor="#FF6633" />
          <stop offset="1" stopColor="#FF541B" />
        </linearGradient>
        <clipPath id="clip0_3753_74673">
          <rect height="32" width="32" fill="white" rx="6.55747" x="2" y="2" />
        </clipPath>
        <clipPath id="clip1_3753_74673">
          <rect
            height="47.0909"
            width="47.0909"
            fill="white"
            transform="translate(-5.8075 -5.80762)"
          />
        </clipPath>
      </defs>
    </SvgIconComponent>
  )
}

const iconPropTypes = {
  size: PropTypes.oneOf(Object.keys(iconSizes))
}

Shovel.propTypes = iconPropTypes
VersionInfo.propTypes = iconPropTypes
AppMobileIcon.propTypes = iconPropTypes

const iconsVersions = {
  Shovel,
  VersionInfo,
  AppMobileIcon
}

export default iconsVersions
